    import React from 'react';
    import API from "../../Services/API";
    import {toast} from "react-toastify";
    import Toast from "../../Components/Toast";
    import Loading from "../../Layouts/Loading";
    import {useNavigate, useParams} from "react-router-dom";
    import Header from "../../Layouts/Header";
    import Navbar from "../../Layouts/Navbar";
    import {AiOutlineAppstoreAdd} from "react-icons/ai";
    import {HiOutlineQrcode} from "react-icons/hi";

    import {BsCalendar4Week} from "react-icons/bs";
    import Barcode from 'react-barcode';

    import {LiaEyeSolid} from "react-icons/lia";
    import {IoMdCheckmarkCircleOutline} from "react-icons/io";
    import {FaCarBattery, FaCubes, FaInfo} from "react-icons/fa";
    import {TbBuildingStore} from "react-icons/tb";

    function BOrderDetails() {
        const navigate = useNavigate();
        const {id} = useParams();
        const [order, setOrder] = React.useState([]);
        const [confirm, setConfirm] = React.useState(0);


        const [isLoaded, setIsLoaded] = React.useState(false);
        const [description, setDescription] = React.useState('');



        React.useEffect(() => {

            const params = {
                'processFor' : 'Sales',
                'sb' : 1
            }

            API.getOrder(params , id)
                .then((response) => {
                    setOrder(response.data);

                    setIsLoaded(true);

                })
                .catch((error) => {

                    if(error.response) {
                        toast.error(error.response.data.message);
                        setTimeout (() => {
                            window.history.back()
                        },400)
                    }
                    else {
                        toast.error(error.message);
                        setTimeout (() => {
                            window.history.back()
                        },400)
                    }
                });


        }, [id ]);


        const onRemoveButtonClick =  (code) => {

            setIsLoaded(false);
            const request = {
                'order_id': id,
                'processFor' : 'Sales',
                code,
                'remove' : 1

            }
            API.updateBOrder( request , id )
                .then((response) => {
                    toast.success(response.message);
                    const params = {
                        'processFor' : 'Vendors',
                        'returned' : 1
                    }

                    API.getOrder(params , id)
                        .then((response) => {
                            setOrder(response.data);
                            setIsLoaded(true);

                        })
                })
                .catch((error) => {
                    setIsLoaded(true);
                    toast.error(error.response.data.message)
                });
        }

        const onStatusButtonClick =  (statusId) => {
            if (!confirm && statusId === 20) {
                toast.error('باتری ها را بررسی کنید  و  درصورت تایید بودن تیک تایید را بزنید')    ;
                return false;
            }


            setIsLoaded(false);
            const request = {
                'order_id': id,
                'status_id' : statusId,
                'processFor' : 'Sales',
                'calc_battery_count' : 1
            }
            API.updateStatus( request )
                .then((response) => {
                    toast.success(response.message);
                    setTimeout(() => {
                        navigate('/sb-orders/');
                    }, 2000);
                })
                .catch((error) => {
                    toast.error(error.response.data.message)
                    setIsLoaded(true);
                });
        }


        return (
            <React.Fragment>
                <Header/>

                <Navbar page="sb-orders"/>
                <Toast/>
                {
                    !isLoaded && <Loading/>
                }
                <main id="main" className="main rtl">

                    <div className="pagetitle mb-5 border-bottom pb-4">
                        <h1>
                            <AiOutlineAppstoreAdd className='ms-2'/>
                           مدیریت سفارش برگشت از فروش
                        </h1>

                    </div>

                    <section className="section">
                        <div className="row">
                            <div className="col-lg-12">

                                <div className="card">
                                    <div className="card-body">
                                        <div className="row mx-2 mb-3 border-bottom pb-2 pt-5">
                                            <div className="col-1">
                                                <TbBuildingStore/>
                                            </div>
                                            <div className="col-5 text-small-2">
                                                نماینده:
                                            </div>
                                            <div className="col-6 text-start fw-bold text-small-2">
                                                {order?.vendor?.title}
                                                &nbsp;
                                                (
                                                {order?.vendor?.city}
                                                )
                                            </div>
                                        </div>
                                        <div className="row mx-2 mb-3 pb-2 ">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-5 text-small-2">
                                                کد یکتای درخواست:
                                            </div>
                                            <div className="col-6 text-start fw-bold text-small-2">
                                                {order.tracking_code}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 pb-2 ">
                                            <div className="col-1">
                                                <BsCalendar4Week/>
                                            </div>
                                            <div className="col-4 text-small-2">
                                                تاریخ ثبت
                                            </div>
                                            <div className="col-7 text-start fw-bold text-small-2">
                                                {order.date}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 pb-2 ">
                                            <div className="col-1">
                                                <FaCubes/>
                                            </div>
                                            <div className="col-4 text-small-2">
                                                تعداد باتری ثبت شده
                                            </div>
                                            <div className="col-7 text-start fw-bold text-small-2">
                                                {order.battery_qty}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 pb-3 border-bottom">
                                            <div className="col-1">
                                                <FaInfo/>
                                            </div>
                                            <div className="col-4 text-small-2">
                                                توضیحات
                                            </div>
                                            <div className="col-7 text-start fw-bold text-small-2">
                                                {order.public_description}
                                            </div>
                                        </div>


                                        <div className="row mx-2 mt-2">

                                            <div className="col-12">

                                                {
                                                    order?.last_status?.id === 14 &&
                                                    <div className="row">

                                                        <div className="col-md-4 p-2 mt-5  ">
                                                            <div
                                                                className="form-check form-switch text-primary">
                                                                <input className="form-check-input"
                                                                       type="checkbox" role="switch"
                                                                       id='confirm'
                                                                       checked={confirm}
                                                                       onChange={(val) => {
                                                                           if (val.target.checked) {
                                                                               setConfirm(1)
                                                                           } else {
                                                                               setConfirm(0)
                                                                           }
                                                                       }}

                                                                />
                                                                <label className="form-check-label "
                                                                       htmlFor='confirm'
                                                                       role="button">
                                                                    کلیه باتری ها بررسی شد و مورد تایید است

                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-1 p-2 mt-5  ">
                                                            &nbsp;
                                                        </div>
                                                        <div className="col-md-4 p-2 mt-5  ">
                                                            <button
                                                                className="btn btn-success text-center text-semi-big w-100 p-2 pr-4 "
                                                                onClick={
                                                                    () => {
                                                                        onStatusButtonClick(20)
                                                                    }
                                                                }
                                                                disabled={!isLoaded}
                                                            >
                                                                تایید سفارش و ارسال به کنترل کیفیت
                                                            </button>
                                                        </div>
                                                        <div className="col-md-3 p-2 mt-5  ">
                                                            <button
                                                                className="btn btn-outline-danger text-center text-small-2 w-100 p-2 pr-4 "
                                                                onClick={
                                                                    () => {
                                                                        onStatusButtonClick(7)
                                                                    }
                                                                }
                                                                disabled={!isLoaded}
                                                            >
                                                                رد درخواست (ارسال به واحد فروش)

                                                            </button>
                                                        </div>
                                                    </div>
                                                }

                                            </div>


                                        </div>


                                        <div className="row mx-2 mb-3 pb-2 list-battery mt-5">
                                            <div className="col-12 text-small-2 border-bottom pb-2 text-primary mt-4">
                                                <FaCarBattery className='ms-2'/>
                                                باتری ها
                                            </div>
                                            <div className="col-12">
                                                <div className='my-4'>

                                                </div>
                                                <div className="row">
                                                    {
                                                        order?.details?.batteries?.map(bt => {
                                                            return (
                                                                <div className="col-md-6  px-3 mt-3" key={bt}>
                                                                    <div className='bg-secondary-subtle rounded p-1 '
                                                                    >
                                                                        <Barcode value={bt} height={20} width={1.5}
                                                                                 fontSize={14}/>
                                                                        <button
                                                                            className='float-start btn btn-outline-danger text-small-3 mt-3 ms-2'
                                                                            onClick={() => {
                                                                                onRemoveButtonClick(bt)
                                                                            }}

                                                                        >
                                                                            عدم تایید (حذف از سفارش)
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                            </div>
                            <div className="col-lg-12">

                                <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">تاریخچه وضعیت های درخواست</h5>
                                        <div className="row">
                                            {
                                                order?.history?.map(stat => {
                                                    return (
                                                        <div className='col-12 mt-2 bg-light text-small-1  p-2'
                                                             key={stat.id}>
                                                            <IoMdCheckmarkCircleOutline className='mx-2'
                                                                                        style={{color:stat.status.color }}
                                                            />
                                                            سفارش در تاریخ:
                                                            &nbsp;
                                                            {stat.date}
                                                            &nbsp;
                                                            در وضعیت
                                                            &nbsp;
                                                            <span className='fw-bold' style={{color:stat.status.color }}>
                                                                {stat.status.title}
                                                            </span>

                                                            &nbsp;
                                                            قرار گرفت.


                                                        </div>
                                                    )

                                                })

                                            }
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                    </section>

                </main>

            </React.Fragment>
        );
    }

    export default BOrderDetails;